import React from 'react';
import { useNavigate } from 'react-router-dom';
import projects from '../projectsData';


const NextProjectButton = ({ currentProjectId }) => {
  const navigate = useNavigate();

  const getCurrentProjectIndex = () => {
    return projects.findIndex(project => project.id === currentProjectId);
  };

  const getNextProject = () => {
    const currentIndex = getCurrentProjectIndex();
    const nextIndex = (currentIndex + 1) % projects.length;
    return projects[nextIndex];
  };

  const handleClick = () => {
    const nextProject = getNextProject();
    navigate(`/project/${nextProject.slug}`);
  };

  return (
    <button
      onClick={handleClick}
      className="next-project-button"
      style={{
        position: 'fixed',
        bottom: '2rem',
        right: '2rem',
        backgroundColor: '#1d7bffff',
        color: '#fff',
        padding: "0.5rem 1rem",
        borderRadius: '5px',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        transition: 'transform 0.2s ease-in-out',
        zIndex: 500
      }}
      onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
      onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
    >
      <span style={{ fontFamily: "Jost, sans-serif" ,fontSize: "0.76rem" }}>Next Project</span>
    </button>
  );
};

export default NextProjectButton;